import { render, staticRenderFns } from "./chengButton.vue?vue&type=template&id=b659004c&scoped=true&"
import script from "./chengButton.vue?vue&type=script&lang=js&"
export * from "./chengButton.vue?vue&type=script&lang=js&"
import style0 from "./chengButton.vue?vue&type=style&index=0&id=b659004c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b659004c",
  null
  
)

export default component.exports